import { PromoterOffer } from 'legacy/events/types';
import React from 'react';

const OfferDetailsHeader = ({ data }: { data?: PromoterOffer }) => {
  const eligibilityCriteria = data?.eligibilityCriteria;
  const rewards = data?.rewards?.kickbackRewards;
  const {
    kind,
    value,
    saleConditions: { unit }
  } = rewards[0];
  const sign = kind === 'amount' ? '$' : '%';
  const totalIndividualUsers = eligibilityCriteria
    .filter((criteria) => criteria.selector === 'users')
    .reduce((acc, criteria) => acc + criteria.ids.length, 0);
  const hasBounceUsers = eligibilityCriteria.filter(
    (criteria) => criteria.selector === 'all'
  );
  const ticketRequired = eligibilityCriteria.filter(
    (criteria) => criteria.selector === 'all' && criteria.mustHaveTicket
  );
  const hasDiscount = data?.discount;
  return (
    <div>
      <div className="text-base font-bold text-[#202020]">{data?.name}</div>
      <div className="mt-4">
        <div className="text-xs font-bold text-[#575757] uppercase">
          Rewards
        </div>
        <div className="mt-1 text-[#202020] text-sm font-bold">
          {`${value}${sign} per ${unit}`}
        </div>
      </div>
      <div className="mt-4">
        <div className="text-xs font-bold text-[#575757] uppercase">
          ELIGIBILITY USERS
        </div>
        {hasBounceUsers.length > 0 && (
          <div className="mt-1 text-[#202020] text-sm font-bold">
            {`Bounce Users ${ticketRequired ? '(with Tickets)' : ''}`}
          </div>
        )}
        {totalIndividualUsers > 0 && (
          <div className="mt-1 text-[#202020] text-sm font-bold">
            {`${totalIndividualUsers} Bounce Users`}
          </div>
        )}
      </div>
      {hasDiscount && (
        <div className="mt-4">
          <div className="text-xs font-bold text-[#575757] uppercase">
            Purchaser Benefits
          </div>
          <div className="flex flex-row">
            <div className="text-[#202020] text-sm font-normal">
              Purchasers pay less with
            </div>
            <div className="font-[600] ml-1 text-[#202020] text-sm">
              {data?.discount?.value}{' '}
              {data?.discount?.kind === 'amount' ? '$' : '%'} discount
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OfferDetailsHeader;
